export const projections = [
  [
    'EPSG:4326',
    '+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees'
  ],
  [
    'EPSG:25831',
    '+proj=utm +zone=31 +ellps=GRS80 +units=m +no_defs'
  ],
  [
    'EPSG:27563',
    '+proj=lcc +lat_1=44.10000000000001 +lat_0=44.10000000000001 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs'
  ],
  [
    'EPSG:25830',
    '+proj=utm +zone=30 +ellps=GRS80 +units=m +no_defs'
  ],
  [
    'EPSG:25829',
    '+proj=utm +zone=29 +ellps=GRS80 +units=m +no_defs'
  ]
]

function convertWorldCoordinates ({ lat, lng }) {
  const wcLat = ((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * Math.pow(2, 0)) * 256
  const wcLng = (lng + 180) / 360 * 256
  return [wcLat, wcLng]
}

export function convertLatLngToTilesGoogle ({ lat, lng }, zoom) {
  const worldCoordinates = convertWorldCoordinates({ lat, lng })
  const x = Math.trunc(worldCoordinates[1] * (1 << zoom) / 256)
  const y = Math.trunc(worldCoordinates[0] * (1 << zoom) / 256)
  return { x, y }
}

export function convertLatLngToTilesTMS ({ lat, lng }, zoom) {
  const googleTiles = convertLatLngToTilesGoogle({ lat, lng }, zoom)
  const yTMS = (1 << zoom) - googleTiles.y - 1
  return { x: googleTiles.x, y: yTMS }
}
